"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SearchListItem_1 = __importDefault(require("./SearchListItem"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const helpers_1 = require("../../../common/helpers/helpers");
const services_1 = require("../../../common/services");
const ActivityDate = styled_components_1.default.div `
  color: rgba(0, 0, 0, 0.6);
  letter-spacing: 2px;
  font-size: 12px;
`;
const ActivitiSearchListItems = ({ contents, userData, currentLocale, timezone, }) => {
    const [activities, setActivities] = (0, react_1.useState)(contents);
    const dates = new Set([]);
    const fetchActivities = (activityList) => __awaiter(void 0, void 0, void 0, function* () {
        let availabilityBatch = [];
        const bookableActivityIds = activityList
            .filter((activity) => activity.bookable)
            .map((activity) => `${activity.contentId}`);
        if (bookableActivityIds.length > 0) {
            availabilityBatch = yield services_1.apiService.getAvailabilities(currentLocale, userData.token, bookableActivityIds);
        }
        const activitiesWithAvailabilities = activityList.map((activity) => {
            const matchingAvailability = availabilityBatch.find((availability) => availability.messageId === activity.contentId);
            return Object.assign({}, activity, {
                availability: matchingAvailability,
            });
        });
        return activitiesWithAvailabilities;
    });
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        if (contents) {
            fetchActivities(contents).then((data) => {
                if (isMounted) {
                    setActivities(data);
                }
            });
        }
        return () => {
            isMounted = false;
        };
    }, [contents]);
    return (activities &&
        activities.map((activity) => {
            const date = activity.start
                ? helpers_1.Helpers.getWeekdayDateAndMonth(activity.start, timezone)
                : "";
            const activityId = activity && activity.deeplink && activity.deeplink.split("--").pop();
            if (!dates.has(date)) {
                dates.add(date);
                return (react_1.default.createElement(react_1.default.Fragment, { key: activityId },
                    react_1.default.createElement(ActivityDate, null, date.toUpperCase()),
                    react_1.default.createElement(SearchListItem_1.default, { content: activity })));
            }
            return react_1.default.createElement(SearchListItem_1.default, { key: activityId, content: activity });
        }));
};
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
    timezone: store.getValue("timezone"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(ActivitiSearchListItems);
